<template>
    <div class="row">
        <div class="col-md-6 order-md-2 mb-4 mb-md-0">
            <integration-form
                v-if="editingId"
                :id="editingId"
                @created="onCreated"
                @updated="onUpdated"
                @cancelled="onCancelled"
            />
            <SbButton v-else variant="primary" @click.prevent="create"
                >Lägg till integration</SbButton
            >
        </div>
        <div class="col-md-6 order-md-1">
            <ul v-if="loaded" class="list-unstyled">
                <li
                    v-for="integration in sortedIntegrations"
                    :key="integration.id"
                    class="mb-4"
                >
                    <div
                        class="d-flex justify-content-between align-items-center"
                    >
                        <div class="mb-2">
                            <h5 class="mb-0">
                                {{ integration.name }}
                            </h5>
                            <p
                                v-if="
                                    integration.associated_quote_profiles
                                        .length > 0
                                "
                                class="small mb-0"
                            >
                                {{
                                    integration.associated_quote_profiles
                                        .map((qp) => qp.listed_name)
                                        .join(", ")
                                }}
                            </p>
                        </div>
                        <div v-if="!editingId">
                            <SbButton
                                size="sm"
                                @click.prevent="edit(integration)"
                                >Redigera</SbButton
                            >
                            <SbButton
                                size="sm"
                                variant="danger"
                                @click.prevent="remove(integration)"
                                >Ta bort</SbButton
                            >
                        </div>
                    </div>
                </li>
            </ul>
            <SbSpinner v-else></SbSpinner>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import axios from "axios";
import IntegrationForm from "./form.vue";
import { Types as IntegrationTypes } from "./types";
const props = defineProps({});
const integrations = ref(null);
const loaded = ref(false);
const editingId = ref(null);
const sortedIntegrations = computed(() => {
  return integrations.value.sort((a, b) => a.name.localeCompare(b.name));
});
async function load() {
  const response = await axios.get(route("integrations.index"));
  integrations.value = response.data.data;
  loaded.value = true;
}
function formattedType(type) {
  const t = IntegrationTypes[type];
  return t ? t.label : "- Okänd (inaktiverad) -";
}
function create() {
  editingId.value = "new";
}
function edit(integration) {
  editingId.value = integration.id;
}
async function remove(integration) {
  if (confirm("Är du säker?")) {
    await axios.delete(route("integrations.destroy", integration.id));
    const idx = integrations.value.findIndex(i => i.id === integration.id);
    integrations.value.splice(idx, 1);
  }
}
function onCreated(integration) {
  integrations.value.push(integration);
  editingId.value = null;
}
function onUpdated(integration) {
  const idx = integrations.value.findIndex(i => i.id === integration.id);
  if (idx !== -1) {
    integrations.value.splice(idx, 1, integration);
  } else {
    integrations.value.push(integration);
  }
  editingId.value = null;
}
function onCancelled() {
  editingId.value = null;
}
onMounted(async () => {
  await load();
});
</script>
